"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrBulkApproveRequestSchema = void 0;
const zod_1 = require("zod");
/**
 * The one request shape every HR bulk-approve endpoint takes (corrections,
 * overtime, leave). Capped at 100 — this is a manager clearing a visible
 * approval queue, not a batch job; a larger number is almost certainly a
 * "select all" against an unfiltered list and should be narrowed first.
 */
exports.hrBulkApproveRequestSchema = zod_1.z.object({
    ids: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(100),
});
//# sourceMappingURL=hr-bulk.schema.js.map